import { z } from 'zod';

const MensajeCompraAgilSchema = z.object({
  id: z.string().nullable(),
  fecha_creacion: z.string().nullable(),
  mensaje: z.string().nullable(),
  compra_agil_id: z.number().nullable(),
  usuario_autor: z.string().nullable(),
  fecha_actualizacion: z.string().nullable(),
  activo: z.boolean().nullable()
});

export const ListarMensajesComprasAgilesResponseSchema = z.array(MensajeCompraAgilSchema);

export type ListarMensajesComprasAgilesResponse = z.infer<typeof ListarMensajesComprasAgilesResponseSchema>;
export type MensajeCompraAgil = z.infer<typeof MensajeCompraAgilSchema>; 